import React from 'react';

import './suggestion-view.scss';

const SuggestionView: React.FC<{ suggestion: any; }> = ({ suggestion }) => {
    return (
        <a href={suggestion.url} className="react-autosuggest__suggestion__view react-autosuggest__suggestion__view--link">
            <div dangerouslySetInnerHTML={{ __html: `${suggestion.highlighted}` }}/>
        </a>
    );
};

export default SuggestionView;
